import React from "react"
import styled from "styled-components"
import RichText from "../../../resolvers/rich-text/rich-text.resolver"
import { AppFunctionComponent, RenderRichText } from "../../../types"

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 9px;
  z-index: 11;
  background-color: ${({ theme }) => theme.color.background};
  box-shadow: 0 1px 20px 0 ${({ theme }) => theme.color.commerceLightShadow};
  text-align: center;
  box-sizing: border-box;

  a {
    font-weight: 400;
    white-space: nowrap;
  }
`

export interface BannerProps {
  text?: RenderRichText
}

const Banner: AppFunctionComponent<BannerProps> = ({ text }) => (
  <Wrapper>{text && <RichText content={text} />}</Wrapper>
)

export default Banner
